import type { JSX } from 'react';

interface Props {
    className?: string;
    size?: string | number;
    color?: string;
}

export const CustomGrowthBars = ({ className, size, color = 'currentColor' }: Props): JSX.Element => {
    const sizeStyle = typeof size === 'number' ? `${size}px` : size;
    return (
        <svg
            viewBox="0 0 15.8333 15.875"
            className={className}
            style={{
                width: sizeStyle || 'inherit',
                height: sizeStyle || 'inherit',
                display: 'flex',
                overflow: 'visible',
                verticalAlign: 'middle',
            }}
            fill="none"
        >
            <path
                d="M4.16667 9.70833V3.33333H6.66667V9.70833L5.41667 8.54167L4.16667 9.70833ZM8.33333 10.9583V0H10.8333V8.45833L8.33333 10.9583ZM0 13.8333V6.66667H2.5V11.3333L0 13.8333ZM0 15.875L5.375 10.5L8.33333 13.0417L13 8.375H11.6667V6.70833H15.8333V10.875H14.1667V9.54167L8.41667 15.2917L5.45833 12.75L2.33333 15.875H0Z"
                fill={color}
            />
        </svg>
    );
};
